import app from "../app";
import Tablesort from 'tablesort'

Tablesort.extend('number',
  (txt) => /[-+]?[\d.,]+(?:e[-+]?\d+)?/.test(txt.replace(/\s/g, '')),
  (a, b) => {
    const toNum = (s) => parseFloat(String(s).replace(/[^0-9.\-]/g, '')) || 0;
    return toNum(a) - toNum(b);
  }
)

const toTime = (s) => {
  let str = String(s || '').trim();
  if (!str) return NaN;

  // epoch seconds / milliseconds
  if (/^\d{10}$/.test(str)) return parseInt(str, 10) * 1000; // seconds
  if (/^\d{13}$/.test(str)) return parseInt(str, 10);        // ms

  // normalize a few common formats to something Date.parse can handle
  str = str
    .replace(/(\d{1,2})(st|nd|rd|th)/gi, '$1') // 1st -> 1
    .replace(/\./g, '-')                       // YYYY.MM.DD -> YYYY-MM-DD
    .replace(/\//g, '-')                       // YYYY/MM/DD -> YYYY-MM-DD
    .replace(/,\s*/g, ' ');                    // "Jan 1, 2024" -> "Jan 1 2024"

  const t = Date.parse(str);
  return Number.isNaN(t) ? NaN : t;
};

Tablesort.extend('date',
  (text) => !Number.isNaN(toTime(text)),           // should this sorter handle it?
  (a, b) => toTime(a) - toTime(b)                  // compare as timestamps
)

export class TableSort {
  constructor() {
    const tables = document.querySelectorAll('[data-table-sort]');

    if ( !tables.length ) return;

    tables.forEach((table) => {
      new Tablesort(table);

      var $table = $(table);

      table.addEventListener('afterSort', function() {
        // Disable scroll reveal once a user has sorted a table to avoid issues where it looks like
        // there are empty rows in the table.
        $table.find('.scroll-reveal').removeClass('scroll-reveal');
      });
    });
  }
}

// Export an init function that looks for and instantiates the module on pageload
export default (() => {
  app.pageLoad.push(() => {
    new TableSort();
  });
})();
